module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp3_8019.4a4f84a9.png";